import { trackEvent } from '../lib/eventTracker'
import { trackFbStandardEvent } from '../lib/fbEvents'

const ERROR_MESSAGE = 'Error fetching price'

let paddlePrice: string | null = null
function getPrice(): undefined | { value: string; currency: string } {
  if (!paddlePrice) {
    return undefined
  }
  const [value, currency] = paddlePrice.split(' ')

  if (!currency || !value) {
    return undefined
  }

  return { value, currency: currency.toUpperCase() }
}

function showPrice(
  price: string,
  priceSpinner: HTMLElement | null,
  pricePlaceholders: NodeListOf<Element>,
) {
  paddlePrice = price
  priceSpinner?.classList.add('hidden')

  pricePlaceholders.forEach((pricePlaceholder) => {
    pricePlaceholder.parentElement?.classList.remove('hidden')
    pricePlaceholder.textContent = price
  })
}

function showOriginalPrice(
  originalPrice: string,
  originalPriceContainer: HTMLElement | null,
  originalPriceEl: HTMLElement | null,
) {
  if (!originalPriceContainer || !originalPriceEl) {
    return
  }

  originalPriceEl.textContent = originalPrice
  originalPriceContainer.classList.remove('hidden')
}

export function PagePremiumView(props: {
  userId: number | null
  paddleProductId: string
  paddlePriceId: string
  email?: string
  discountCode?: string
  discountId?: string
}) {
  const pricePlaceholders = document.querySelectorAll('.price_placeholder')
  const priceSpinner = document.getElementById('price_spinner')
  const premiumButton = document.getElementById('premium_button')
  const originalPriceContainer = document.getElementById('original_price_container')
  const originalPriceEl = document.getElementById('original_price')

  const Paddle = (window as any).Paddle

  if (!Paddle) {
    console.error('Paddle not found')
    alert(ERROR_MESSAGE)
    return
  }

  const basePriceRequest = {
    items: [
      {
        quantity: 1,
        priceId: props.paddlePriceId,
      },
    ],
  }

  function validateItem(item: any): boolean {
    if (!item) {
      console.error('No item found')
      alert(ERROR_MESSAGE)
      return false
    }

    if (item.product.id !== props.paddleProductId) {
      console.error('Invalid product id')
      alert(ERROR_MESSAGE)
      return false
    }

    return true
  }

  if (props.discountId) {
    const discountedPriceRequest = {
      ...basePriceRequest,
      discountId: props.discountId,
    }

    Promise.all([
      Paddle.PricePreview(basePriceRequest),
      Paddle.PricePreview(discountedPriceRequest),
    ])
      .then(([baseResult, discountedResult]: [any, any]) => {
        const baseItem = baseResult.data.details.lineItems[0]
        const discountedItem = discountedResult.data.details.lineItems[0]

        if (!validateItem(baseItem) || !validateItem(discountedItem)) {
          return
        }

        const originalPrice = baseItem.formattedTotals.total
        const discountedPrice = discountedItem.formattedTotals.total

        showOriginalPrice(originalPrice, originalPriceContainer, originalPriceEl)
        showPrice(discountedPrice, priceSpinner, pricePlaceholders)
      })
      .catch((error: any) => {
        console.error('Error fetching price', error)
        alert(ERROR_MESSAGE)
      })
  } else {
    Paddle.PricePreview(basePriceRequest)
      .then((result: any) => {
        const item = result.data.details.lineItems[0]

        if (!validateItem(item)) {
          return
        }

        showPrice(item.formattedTotals.total, priceSpinner, pricePlaceholders)
      })
      .catch((error: any) => {
        console.error('Error fetching price', error)
        alert(ERROR_MESSAGE)
      })
  }

  Paddle.Update({
    eventCallback: (event: { name: string }) => {
      if (event.name === 'checkout.payment.initiated') {
        trackFbStandardEvent('AddPaymentInfo')
      }

      if (event.name === 'checkout.completed') {
        const priceData = getPrice()
        trackFbStandardEvent('Purchase', priceData)
      }

      if (event.name === 'checkout.loaded') {
        document.body.style.overflow = 'hidden'
      }

      if (event.name === 'checkout.closed') {
        document.body.style.overflow = 'auto'
      }
    },
  })

  premiumButton?.addEventListener('click', () => {
    const priceData = getPrice()
    trackFbStandardEvent('InitiateCheckout', priceData)

    if (!props.userId) {
      alert('Please try again layeter.')

      return
    }

    const checkoutRequest = {
      ...basePriceRequest,
      settings: {
        allowLogout: false,
        theme: 'light',
        displayMode: 'overlay',
        variant: 'one-page',
      },
      ...(props.email ? { customer: { email: props.email } } : {}),
      ...(props.discountCode ? { discountCode: props.discountCode } : {}),
      customData: {
        userId: props.userId,
      },
    }

    try {
      trackEvent('open_premium_checkout')
      Paddle.Checkout.open(checkoutRequest)
    } catch (error: any) {
      console.error(error)
      alert('Failed to checkout')
    }
  })
}
